export default "<p>view-modal works!</p>\n"